import {DEFAULT_WORKSPACE_KEY} from './default-workspace-key';

export function clearDefaultWorkspace() {
  window.localStorage.removeItem(DEFAULT_WORKSPACE_KEY);
}
